module.exports = __webpack_public_path__ + "img/Bluparadise_Valencia_Nuria_Daviu_WEB-117.78c0431f.jpg";